var _defs, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2361.78 2028.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9d6828;}.cls-1,.cls-2{opacity:0.53;}.cls-2{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2290.01 0 1098.76 0 1026.98 0 1026.98 71.78 1026.98 971.08 506.59 971.08 506.59 661.19 434.81 661.19 434.81 971.08 434.81 1042.86 434.81 1377.59 506.59 1377.59 506.59 1042.86 1026.98 1042.86 1026.98 1377.59 1098.76 1377.59 1098.76 71.78 2290.01 71.78 2290.01 1956.99 1579.12 1956.99 1579.12 2028.77 2290.01 2028.77 2361.78 2028.77 2361.78 1956.99 2361.78 71.78 2361.78 0 2290.01 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.78 2028.77 1263.02 2028.77 1334.8 2028.77 1334.8 1956.99 1334.8 1057.69 1855.19 1057.69 1855.19 1367.58 1926.97 1367.58 1926.97 1057.69 1926.97 985.92 1926.97 651.18 1855.19 651.18 1855.19 985.92 1334.8 985.92 1334.8 651.18 1263.02 651.18 1263.02 1956.99 71.78 1956.99 71.78 71.78 782.66 71.78 782.66 0 71.78 0 0 0 0 71.78 0 1956.99 0 2028.77 71.78 2028.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72f0542e3a9e403c2b98a616539c3557.svg";
export { ForwardRef as ReactComponent };